import script from "./LeftColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftColumn.vue?vue&type=script&setup=true&lang=js"

import "./LeftColumn.vue?vue&type=style&index=0&id=563da746&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563da746"]])

export default __exports__